define(['bignumber.js'], (BigNumber) => {
    const copy = (obj) => ({...obj});

    const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

    // unicode symbols
    const mdash = String.fromCharCode(8212); // https://www.fileformat.info/info/unicode/char/2014/index.htm
    const nbsp = String.fromCharCode(160); // http://www.fileformat.info/info/unicode/char/00a0/index.htm


    function applyVatIfNeeded (value, vat) {

        // assumed that vat is BigNumber or false-value
        if (vat) {
            const bigNumberVal = new BigNumber(value);
            return bigNumberVal.times(vat).toFixed(2);
        }
        return value;
    }

    function clear (params, valuesToClear = [undefined, null]) {
        const clear = new Set(valuesToClear);
        return Object.entries(params).reduce((all, [key, value]) => {
            if (!clear.has(value)) {
                all[key] = value;
            }
            return all;
        }, {});
    }

    function sortNumericArray (array, desc = false) {
        if (desc) {
            return array.sort((a, b) => b - a);
        }
        return array.sort((a, b) => a - b);
    }

    function sorted (array, sort = (arr) => arr.sort()) {
        return sort(array.slice());
    }

    function sortedNumericArray (array) {
        return sorted(array, sortNumericArray);
    }

    return {
        mdash,
        nbsp,
        copy,
        daysInWeek: 7,
        hoursInDay: 24,
        capitalize,
        applyVatIfNeeded,
        clear,
        sortNumericArray,
        sorted,
        sortedNumericArray
    };
});
